import React from 'react';

import SimpleTable from "../../components/Common/Elements";

import {Alert, Card, CardContent, Grid, Stack, Table, TableBody, TableCell, TableRow, Typography} from "@mui/material";


import Loading from "../../components/Common/Loading";
import {
    formatDate, getDeviceIdAbsentWarning,
    paymentUserStatus,
    timestampToDate
} from "../../core/utils/constants";

import {useSelector} from "react-redux";
import {useParams, useSearchParams} from 'react-router-dom';
import {format} from "date-fns";
import {useGetStateV2TOHQuery} from "../../core/api/toh-state-api";
import TechInfoTOH from "../TechInfo/techInfoTOH";
import UserSocialInfoTOH from "../UserInfo/userSocialInfoTOH";
import TohBanStatusCard from "../BanControl/TohBanStatusCard"
import TohMuteStatusCard from "../BanControl/TohMuteStatusCard"
import TohAvatarChangeBlockStatusCard from "../BanControl/TohAvatarChangeBlockStatusCard"
import SpammerControl from "../BanControl/SpammerControl";
import StateCopyLogCard from "../../components/Common/StateCopyLogCard";


function DashboardTOH() {

    const {deviceId: deviceIdParam} = useParams();
    const [searchParams] = useSearchParams();
    const deviceId = deviceIdParam ?? "";
    const stateId = searchParams.get('vendorId') ?? "";
    const deviceIdIsEmpty = !deviceId && !stateId;

    const {
        data: obj,
        isLoading,
        isFetching,
        isSuccess,
        isError,
        error
    } = useGetStateV2TOHQuery({deviceId, stateId}, {skip: deviceIdIsEmpty})



    let panel1 = ""
    //
    // useEffect(() => {
    //     console.log(deviceIdIsEmpty)
    //     
    // }, [CommonData])
    //
    // useEffect(() => {
    //     
    // }, [])
    //
    // 

    

    if (typeof obj === "object" && obj.hasOwnProperty('data')) {
        try {
            const data = JSON.parse(obj.data)

            if(data.hasOwnProperty('User')) {

                let source = {
                    account_info: [],
                    progress_info: []
                }


                // let lastSession = ''
                // if (data.hasOwnProperty('LastSessionsState')) {
                //     lastSession = getLastSession(data.LastSessionsState._lastSessions)
                //     lastSession = formatDate(lastSession)
                // }
                // if (data.hasOwnProperty('SessionsState')) {
                //     lastSession = getLastSession(data.SessionsState._lastSessions)
                //     lastSession = formatDate(lastSession)
                // }

                source = {
                    cities: data['Cities'],
                    account_info: [
                        ["User ID", data?.User],
                        ["ClientVer", data?.ClientVer._major+'.'+data?.ClientVer._minor +'.' +data?.ClientVer._build],
                        ["InitialClientVer", data.InitialClientVer._major+'.'+data.InitialClientVer._minor +'.' +data.InitialClientVer._build],
                        ["Reg", data.hasOwnProperty('Reg')?format(data?.Reg*1000, 'dd.MM.yyyy HH:mm:ss'):0],
                        ["SessionTimestamp", data.hasOwnProperty('SessionTimestamp')?format(data?.SessionTimestamp*1000, 'dd.MM.yyyy HH:mm:ss'):0],
                        ["PrevSessionTimestamp", data.hasOwnProperty('PrevSessionTimestamp')?format(data?.PrevSessionTimestamp*1000, 'dd.MM.yyyy HH:mm:ss'):0],
                        ["Save ID", data?.SaveId],
                    ],
                    setting: data.hasOwnProperty('Settings')?Object.keys(data.Settings).map((key) => ([key, data.Settings[key].toString()])):[],
                    payment_info: [
                        [
                            "Segment",
                            paymentUserStatus(data.Payment.Stat.Sum)
                        ],
                        [
                            "Total",
                            Math.floor(data.Payment.Stat.Sum)
                        ],
                        [
                            "Lst",
                            Math.floor(data.Payment.Stat.Lst)
                        ],
                        [
                            "Max",
                            Math.floor(data.Payment.Stat.Max)
                        ],
                        [
                            "Cnt",
                            Math.floor(data.Payment.Stat.Cnt)
                        ],
                        [
                            "Last payment date",
                            formatDate(timestampToDate(data.Payment.Stat.Date))
                        ]
                    ],
                }


                panel1 = <Grid container spacing={2}>
                    <Grid size={4}>
                        <Card>
                            <CardContent>
                                <Typography sx={{fontSize: 16}}>
                                    Account Info
                                </Typography>
                            </CardContent>

                            <SimpleTable data={source.account_info}/>
                            <Stack direction="column" sx={{ p: 2, rowGap: 1 }}>
                                <SpammerControl userId={deviceId} project="toh" />
                            </Stack>
                        </Card>
                    </Grid>

                    <Grid size={4}>
                        <Card>
                            <CardContent>
                                <Typography sx={{fontSize: 16}}>
                                    Current City
                                </Typography>
                            </CardContent>
                            {source.cities&& <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>CityId</TableCell>
                                        <TableCell>{source.cities.CityId}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Started</TableCell>
                                        <TableCell>{source.cities.Started==true?'Yes':'No'}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Completed</TableCell>
                                        <TableCell>{source.cities.Completed}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>LatestQuest</TableCell>
                                        <TableCell>{source.cities?.Cities[source.cities.CityId]?.LatestQuest}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>}
                        </Card>

                    </Grid>

                    <Grid size={4}>
                        <Stack direction="column" spacing={2}>
                            <TohBanStatusCard userId={deviceId}/>
                            <TohAvatarChangeBlockStatusCard userId={deviceId}/>
                        </Stack>
                    </Grid>

                    <Grid size={4}>
                        <TechInfoTOH isSimple={true} deviceId={deviceId}/>


                    </Grid>
                    <Grid size={4}>
                        <Card>
                            <CardContent>
                                <Typography sx={{fontSize: 16}}>
                                    Payment Info
                                </Typography>
                            </CardContent>
                            <SimpleTable data={source.payment_info}/>
                        </Card>
                    </Grid>

                    <Grid size={4}>
                        <TohMuteStatusCard userId={deviceId}/>
                    </Grid>

                    <Grid size={4}>
                        <Card>
                            <CardContent>
                                <Typography sx={{fontSize: 16}}>
                                    Settings
                                </Typography>
                            </CardContent>

                            {source.setting&&<SimpleTable data={source.setting}/>}
                        </Card>

                    </Grid>
                    <Grid size={4}>
                        <UserSocialInfoTOH deviceId={deviceId}/>
                    </Grid>

                    <Grid size={12}>
                        <StateCopyLogCard logs={obj?.copyLogs}/>
                    </Grid>
                </Grid>


            } else if (typeof obj === "object" && obj.data.hasOwnProperty('error')) {
                panel1 = obj.data.error
            }

        } catch (e) {
            panel1 = <Alert severity={"warning"}>Unable to parse, not JSON</Alert>
        }


    } else {
        panel1 = 'unknown error'
    }

    return (
        <>
            {deviceIdIsEmpty ? getDeviceIdAbsentWarning() :
                <Loading
                    isLoading={isLoading||isFetching}
                    isError={isError}
                    error={error}
                >
                    {panel1}
                </Loading>}

        </>
    );

}

export default DashboardTOH
